module.exports = __webpack_public_path__ + "media/images/caution-76fcb1b30ef472b531d9d12da9a29d3c.png";